import classNames from 'classnames';
import { type GroupBase, type SelectComponentsConfig, components } from 'react-select';

import type { Country } from '../../../features/geography/types';
import { CountryCodeDisplay } from '../CountryCodeDisplay/CountryCodeDisplay';

import styles from './Option.module.scss';

export const Option: SelectComponentsConfig<
  Country,
  false,
  GroupBase<Country>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>['Option'] = ({ children, className, ...props }) => (
  <components.Option className={classNames(className, styles.option)} {...props}>
    <CountryCodeDisplay country={props.data} />
  </components.Option>
);
